/**
 * Dependências externas
 */
import React from 'react';
import { connect as connectToFormik } from 'formik';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  RadioGroup,
  Radio
} from '@chakra-ui/core';

/**
 * Dependências internas
 */
import getInformacoesDoCampo from '../../../../../utils/form/getInformacoesDoCampo';

const Despesa = props => {
  const nomeDoCampo = 'despesa';

  const { formik, ...rest } = props;

  const { handleChange, handleBlur } = formik;

  const { valor, erro, possuiErroDeValidacao } = getInformacoesDoCampo(
    props,
    nomeDoCampo
  );

  return (
    <FormControl isInvalid={possuiErroDeValidacao} {...rest}>
      <FormLabel htmlFor={nomeDoCampo}>Despesa</FormLabel>
      <RadioGroup
        isInline
        spacing={4}
        value={valor}
        onChange={handleChange}
        onBlur={handleBlur}
        name={nomeDoCampo}
      >
        <Radio value="ADMINISTRACAO" size="md" isDisabled={rest.isDisabled}>
          Administração
        </Radio>
        <Radio value="CONDOMINO" isDisabled={rest.isDisabled}>
          Condomino
        </Radio>
      </RadioGroup>
      {possuiErroDeValidacao && <FormErrorMessage>{erro}</FormErrorMessage>}
    </FormControl>
  );
};

export default connectToFormik(Despesa);
